const routes = [
    {
        path: "/",
        component: () => import("../Pages/Home.vue"),
        name: "home",
    },
    {
        path: "/vietvardi",
        component: () => import("../Pages/AllToponyms.vue"),
        name: "allToponyms",
    },
    {
        path: "/par-datubazi",
        component: () => import("../Pages/AboutDatabase.vue"),
        name: "database",
    },
    {
        path: "/par-sikdatnem",
        component: () => import("../Pages/CookiesPolicy.vue"),
        name: "cookiesPolicy",
    },
    {
        path: "/padomi-vaksana",
        component: () => import("../Pages/Advice.vue"),
        name: "advice",
    },
    {
        path: "/talkas-statistika",
        component: () => import("../Pages/Statistics.vue"),
        name: "statistics",
    },
    {
        path: "/instrukcija",
        component: () => import("../Pages/Instruction.vue"),
        name: "instruction",
    },
    {
        path: "/kontakti",
        component: () => import("../Pages/Contacts.vue"),
        name: "contacts",
    },
    {
        path: "/privatuma-politika",
        component: () => import("../Pages/PrivacyAndTerms.vue"),
        name: "privacyAndTerms",
    },
    {
        path: "/paroles/atjaunosana/:token",
        component: () => import("../Pages/PasswordReset.vue"),
        name: "passwordReset",
    },
    {
        path: "/paroles-atjaunosanas-pieprasijums",
        component: () => import("../Pages/SendResetPasswordLink.vue"),
        name: "sendResetPasswordLink",
    },
    {
        path: "/vietvards/:id",
        component: () => import("../Pages/ToponymView.vue"),
        name: "toponymView",
    },
    {
        path: "/vietvardu-karte",
        component: () => import("../Pages/ToponymsMap.vue"),
        name: "toponymsMap",
    },
    {
        path: "/epasta/apstiprinasana/:id/:hash",
        component: () => import("../Pages/EmailVerification.vue"),
        name: "emailVerification",
    },
    {
        path: "/lietotajs-apstiprinats",
        component: () => import("../Pages/UserApproved.vue"),
        name: "userApproved",
    },
    {
        path: "/lietotaja-konts",
        component: () => import("../Pages/UserProfile.vue"),
        name: "userProfile",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "*",
        component: () => import("../Pages/PageNotFound.vue"),
        name: "pageNotFound",
    },
];

export default routes;
